import React from "react"

export const COLUMNS = [
  {
    Header: "Mode of Payment",
    accessor: "paymentMode",
  },
  // {
  //   Header: 'Type',
  //   accessor: 'type',
  // },
  // {
  //   Header: 'Fee(%)',
  //   accessor: 'feePercentage',
  // },

  {
    Header: "",
    accessor: "Edit",
    Cell: ({ cell: {} }) => (
      <img
        className="eye-icon"
        src={"../../../assets/images/CRedit.svg"}
        width={32}
        height={30}
        style={{
          marginTop: "6px",
          paddingRight: "15px",
          width: "40px",
          height: "40px",
        }}
        alt="Edit"
      />
    ),
  },
  {
    Header: "",
    accessor: "Delete",
    // @ts-ignore
    Cell: ({ cell }) => (
      <img
        className="eye-icon"
        src={"../../../assets/images/CRdelete.svg"}
        width={32}
        height={30}
        style={{
          marginTop: "6px",
          paddingRight: "15px",
          width: "40px",
          height: "40px",
        }}
        alt="Delete"
      />
    ),
  },
]
